import { Injectable } from '@angular/core';
import DOMPurify from 'dompurify';

@Injectable({ providedIn: 'root' })
export class SanitizationService {
  sanitize(value: string | null | undefined): string {
    if (!value) return '';
    return DOMPurify.sanitize(value, {
      ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'br', 'a'],
      ALLOWED_ATTR: ['href', 'target', 'rel'],
    });
  }
}
